export default function AddRound({ color = "#f89900" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.813"
      height="20.751"
      viewBox="0 0 17.813 20.751"
    >
      <g
        id="Group_1028"
        data-name="Group 1028"
        transform="translate(-1802.561 -583.253)"
      >
        <g
          id="Group_938"
          data-name="Group 938"
          transform="translate(320.561 221.253)"
        >
          <g
            id="Rectangle_2494"
            data-name="Rectangle 2494"
            transform="translate(1482 364)"
            fill={color}
            stroke={color}
            stroke-width="1"
          >
            <rect width="15" height="14" rx="2" stroke="none" />
            <rect x="0.5" y="0.5" width="14" height="13" rx="1.5" fill="none" />
          </g>
          <g
            id="Ellipse_2604"
            data-name="Ellipse 2604"
            transform="translate(1487 362)"
            fill="#fff"
            stroke={color}
            stroke-width="1"
          >
            <ellipse cx="2.5" cy="2" rx="2.5" ry="2" stroke="none" />
            <ellipse cx="2.5" cy="2" rx="2" ry="1.5" fill="none" />
          </g>
          <g
            id="Rectangle_2493"
            data-name="Rectangle 2493"
            transform="translate(1484 366)"
            fill="#fff"
            stroke={color}
            stroke-width="1"
          >
            <rect width="11" height="4" stroke="none" />
            <rect x="0.5" y="0.5" width="10" height="3" fill="none" />
          </g>
          <g
            id="Rectangle_2495"
            data-name="Rectangle 2495"
            transform="translate(1484 369)"
            fill="#fff"
            stroke={color}
            stroke-width="1"
          >
            <rect width="11" height="4" stroke="none" />
            <rect x="0.5" y="0.5" width="10" height="3" fill="none" />
          </g>
          <g
            id="Rectangle_2496"
            data-name="Rectangle 2496"
            transform="translate(1484 372)"
            fill="#fff"
            stroke={color}
            stroke-width="1"
          >
            <rect width="11" height="4" stroke="none" />
            <rect x="0.5" y="0.5" width="10" height="3" fill="none" />
          </g>
        </g>
        <g
          id="Rectangle_2502"
          data-name="Rectangle 2502"
          transform="matrix(-0.809, -0.588, 0.588, -0.809, 1813.32, 599.149)"
          fill={color}
          stroke="#fff"
          stroke-width="1"
        >
          <rect width="5" height="12" stroke="none" />
          <rect x="0.5" y="0.5" width="4" height="11" fill="none" />
        </g>
        <g
          id="Polygon_283"
          data-name="Polygon 283"
          transform="matrix(-0.809, -0.588, 0.588, -0.809, 1809.793, 604.004)"
          fill="#fff"
        >
          <path
            d="M 4.249997615814209 5.5 L 0.7500025033950806 5.5 L 2.5 1.300006031990051 L 4.249997615814209 5.5 Z"
            stroke="none"
          />
          <path
            d="M 2.5 2.600012063980103 L 1.500005006790161 5 L 3.499994993209839 5 L 2.5 2.600012063980103 M 2.5 0 L 5 6 L 0 6 L 2.5 0 Z"
            stroke="none"
            fill="#fff"
          />
        </g>
        <path
          id="Polygon_284"
          data-name="Polygon 284"
          d="M1.5,0,3,6H0Z"
          transform="matrix(-0.809, -0.588, 0.588, -0.809, 1810.175, 601.828)"
          fill={color}
        />
      </g>
    </svg>
  );
}
